import React, { useState, useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
import _ from "lodash";
import { Container, Row } from "react-bootstrap";

import { SearchResult } from "components/SearchResult";
import { DegreeFilter } from "components/DegreeFilter";
import { GlobalState } from "contexts/GlobalState";
import { GET_FAVORITES } from "../../schemas/favorite";
import InfiniteScroll from "react-infinite-scroller";
import { GET_PROGRAMS } from "schemas/program";
import { EmptyResults } from "components/EmptyResults";
import "./style.scss";

export const SearchResults = ({ labels }) => {
  const [globalSearch, setGlobalSearch] = GlobalState("search");
  const [results, setResults] = useState([]);
  const [globalCalc, setGlobalCalc] = GlobalState("calc");
  const [hasMore, setHasMore] = useState(true);
  const [from, setFrom] = useState(0);
  const [refetch, setRefetch] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  
  const [getPrograms, { loading: programLoading, data: programData }] = useLazyQuery(GET_PROGRAMS, {
    fetchPolicy: "no-cache",
  });

  const [getFavorites, { data }] = useLazyQuery(GET_FAVORITES, {
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (from === 0 && refetch > 0) {
      handleFetch();
    }
  }, [refetch])

  useEffect(() => {
    getFavorites();
  }, []);

  useEffect(() => {
    setIsLoading(false);
    setFrom(0);
    setRefetch(prevState => prevState + 1);
    setResults([]);
    setHasMore(true);
  }, [globalSearch.filters]);

  useEffect(() => {
    if (!programLoading && programData) {
      if (programData?.getPrograms?.results < 10) {
        setHasMore(false);
      }
      setResults(prevState => prevState.concat(programData?.getPrograms?.results))
      setIsLoading(false);
      setFrom(prevState => prevState + 10);
    }
  }, [programData])

  const handleFetch = () => {
    if (!isLoading) {
      getPrograms({
        variables: {
          search: { ...globalSearch.filters, from: from, degreesKeys: labels.terms.twr_filtered }
        }
      })
      setIsLoading(true);
    }
  }

  const styleFromCalculator = () => {
    if (labels.is_calculator) {
      if (globalCalc.showOtherWidgets) {
        return "in-calculator";
      }
      return "hide";
    }
    return "";
  }

  return (
    <Container
      tabIndex="-1"
      className={`search-results ${styleFromCalculator()}`}
      aria-label={`${labels.newSearchResults} ${globalSearch.results.length} ${labels.results}`}>
      {!Utils.isMobile() && !labels.is_calculator && (
        <Row>
          <DegreeFilter {...labels.terms}></DegreeFilter>
        </Row>
      )}
      <InfiniteScroll
        pageStart={0}
        loadMore={handleFetch}
        hasMore={hasMore}
        useWindow={true}
        loader={
          <div key={0} className="loader-ellips">
            <span className="loader-ellips__dot"></span>
            <span className="loader-ellips__dot"></span>
            <span className="loader-ellips__dot"></span>
            <span className="loader-ellips__dot"></span>
          </div>
        }
      >
        {results.length !== 0 ? (
          results.map((item, index) => (
            <SearchResult
              key={`${item.nid}_${item.langcode}`}
              id={`searchResult${index}`}
              item={item}
              favorite={Utils.isFavorite(item.nid, data)}
              addToFavoriteLabels={labels.FavoriteButtonsWrapper.labels}
              labels={labels}
              getAllFavorites={getFavorites}
              inCalcPage={labels.is_calculator}
            />
          ))
        ) : !programLoading && (
          <EmptyResults
          labels={labels}>
          </EmptyResults>
        )}
      </InfiniteScroll>
    </Container>
  );
};